import { EXO_SKELETON_RUNTIME_SCOPE } from './consts';
import { createUniqueRequestId, getExoSkeletonRuntime } from './internal';
export function createRuntimeDataEvent(type, data) {
  return {
    requestId: createUniqueRequestId(type),
    type,
    data,
    eventTimestampUTC: new Date(new Date().toUTCString()).getTime()
  };
}
export function isInExoSkeleton() {
  var _window$EXO_SKELETON_;
  return Boolean((_window$EXO_SKELETON_ = window[EXO_SKELETON_RUNTIME_SCOPE]) === null || _window$EXO_SKELETON_ === void 0 ? void 0 : _window$EXO_SKELETON_.available);
}
function registerExoSkeletonListener(type) {
  const runtime = getExoSkeletonRuntime();
  if (!runtime.listeners) {
    runtime.listeners = [];
  }
  runtime.listeners.push(type);
  runtime.listeners = Array.from(new Set(runtime.listeners));
}
export function removeExoSkeletonListener(type) {
  const runtime = getExoSkeletonRuntime();
  if (!runtime.listeners) {
    runtime.listeners = [];
  }
  runtime.listeners = runtime.listeners.filter(listener => listener !== type);
}
export function hasExoSkeletonListenerInitialized(type) {
  const runtime = getExoSkeletonRuntime();
  if (!runtime.listeners) {
    runtime.listeners = [];
  }
  return runtime.listeners.includes(type);
}
export function createPostMessageEventHandler(type, callback) {
  registerExoSkeletonListener(type);
  window.addEventListener('message', callback);
  return {
    dispose() {
      removeExoSkeletonListener(type);
      window.removeEventListener('message', callback);
    }
  };
}
export function sendRuntimeDataEvent(type, data) {
  const targetOrigin = window.location.origin;
  const event = createRuntimeDataEvent(type, data);
  return new Promise(resolve => {
    const listenerCallback = _ref => {
      let {
        data: eventData
      } = _ref;
      if ((eventData === null || eventData === void 0 ? void 0 : eventData.requestId) === event.requestId) {
        resolve(eventData);
        window.removeEventListener('message', listenerCallback);
      }
    };
    window.addEventListener('message', listenerCallback);
    try {
      window.postMessage(event, targetOrigin);
    } catch (e) {
      const originalEventData = event.data;
      event.data = JSON.parse(JSON.stringify(event.data));
      window.postMessage(event, targetOrigin);
      console.error('Failed to send parse "postMessage" data, fallback to "JSON.parse(JSON.stringify(...))"', e, event, originalEventData);
    }
  });
}
//# sourceMappingURL=runtime.js.map